<app-widget [widget-meta]="this.data" hidehelp="false">
    <ng-container *ngIf="profileService.profile$ | async as profile; else loading">
        <div *ngIf="cms.getV2ContentByTypes$ | async as data; else loading">
            <ng-container *ngIf="profile.favorites.length > 0; else noRequests">
                <ng-container *ngFor="let item of data  | linkFilter: filterText; count as c">
                    <div class="content favorites-link pl-4" [ngSwitch]="item.Type" *ngIf="profile.favorites.includes(item.Id)">
                        <span class="icon icon-favorites-edit" [ngClass]="editStatus ? 'show-favorites-button' : 'hide-favorites-button'" (click)="updateFavorite(profile.favorites, item)" [attr.aria-label]="profile.favorites.includes(item.Id)?'Favorite':'Not Favorite'">
                            <i class="fas fa-trash-alt" aria-hidden="true" [class.active]="profile.favorites.includes(item.Id)" title="Unfavorite this link?"></i>
                        </span>
                        <a *ngSwitchCase="'External Link'" href="{{item.Uri}}" target="_blank">{{item.Title}}</a>
                        <a *ngSwitchCase="'Link'" href="{{item.Uri}}" target="_blank">{{item.Title}}</a>
                        <ng-container *ngSwitchCase="'Document'">
                            <ng-container [ngSwitch]="item.DocumentType">
                                <a *ngSwitchCase="'link'" href="{{item.Uri}}" target="_blank">{{item.Title}}</a>
                                <a *ngSwitchDefault href="/document?id={{item.Id}}&type=Documents" (click)="cms.downloadById(item.Id, $event)">{{item.Title}}</a>
                            </ng-container>
                        </ng-container>
                        
                        <span *ngSwitchDefault>{{item.Title}}</span>
                        <hr class="tiles-favorites-divider" />
                    </div>
                </ng-container>
            </ng-container>
            @if(!!profile.favorites.length){
                <div class="justify-content-center d-flex favorites-edit">
                    <button type="button" class="btn btn-link" (click)="toggleEdit()">
                        <i class=" far fa-edit fa-2x"></i>
                        <span class="sr-only">Edit favorites</span>
                    </button>
                </div>
            }
        </div>
    </ng-container>
    
    <ng-template #noRequests>
        <div class="favorites-links no-results text-center">
            You currently have no favorites. <br/>Click the Links or the Files and Forms tiles to get started!
        </div>
    </ng-template>
    
    <ng-template #loading>
        <div class="widget-loading text-center">
            <i class="fas fa-circle-notch fa-spin"></i>
        </div>
    </ng-template>
</app-widget>

